var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['menu-icon-mobile', _vm.isclose ? 'menu-icon-mobile-close' : ''],on:{"click":_vm.handle}},[_c('li',{staticClass:"before"}),_vm._v(" "),_c('li',{staticClass:"after"})])}
var staticRenderFns = []

export { render, staticRenderFns }